import PropTypes from 'prop-types';
export const brandPropTypes = {
  address: PropTypes.string,
  contact: PropTypes.shape({
    heading: PropTypes.string,
    email: PropTypes.string,
    tel: PropTypes.string,
    operatingHours: PropTypes.string
  }),
  socials: PropTypes.shape({
    heading: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      href: PropTypes.string,
      title: PropTypes.string
    }))
  })
};